import { render, staticRenderFns } from "./SmsTemplateModal.vue?vue&type=template&id=143cf28e&scoped=true&"
import script from "./SmsTemplateModal.vue?vue&type=script&lang=js&"
export * from "./SmsTemplateModal.vue?vue&type=script&lang=js&"
import style0 from "./SmsTemplateModal.vue?vue&type=style&index=0&id=143cf28e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "143cf28e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Kevin\\Documents\\source\\locate2u-server\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('143cf28e')) {
      api.createRecord('143cf28e', component.options)
    } else {
      api.reload('143cf28e', component.options)
    }
    module.hot.accept("./SmsTemplateModal.vue?vue&type=template&id=143cf28e&scoped=true&", function () {
      api.rerender('143cf28e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/TeamSettings/CustomActions/Sms/SmsTemplateModal.vue"
export default component.exports